import React from "react";
import PropTypes from "prop-types";
import { connect } from "unistore/preact";
import { actions } from "actions";
import { stringReplace } from "utils";
import FlexMatrixQuestionRow from "components/questions/FlexMatrixQuestionRow";

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/questions/FlexMatrixQuestion.scss';

const FlexMatrixQuestion = ({ question, onOptionChanged, isDisabled }) => {
  const { rows, columns, id, text } = question;
  const flexMatrixId = stringReplace(id, "/", "-");

  return (
    <fieldset className="csw-fieldset csw-q-flex-mtrx">
      <legend className="sr-only" aria-hidden={true}>
        {text}
      </legend>

      {rows &&
        rows.map((row, index) => {
          const rowId = `${flexMatrixId}-${index}`; // This must be uniq and include index

          return (
            <FlexMatrixQuestionRow
              key={rowId}
              rowId={rowId}
              row={row}
              columns={columns}
              isDisabled={isDisabled}
              onOptionSelected={(option, row) => onOptionChanged({ option, row })}
            />
          );
        })}
    </fieldset>
  );
};

FlexMatrixQuestion.propTypes /* remove-proptypes */ = {
  question: PropTypes.object.isRequired,
  onOptionChanged: PropTypes.func,
  isDisabled: PropTypes.bool,
};

export default connect("", actions)(FlexMatrixQuestion);
